"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";

// بدون loading: صفحه‌ی اول داده روی سرور گرفته می‌شود و کارت‌ها مستقیم SSR می‌شوند؛
// اسکلت loading فقط قبل از محتوای واقعی در html می‌آمد.
const Component = dynamic(() => import("./_component"));

export default Component;
